// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const HarEntryDecodeStatusSchema = z.enum(['DECODED','PARTIAL','NO_SCHEMA','UNSUPPORTED_ENCODING','FAILED'] as const);

export type HarEntryDecodeStatusType = `${z.infer<typeof HarEntryDecodeStatusSchema>}`

export default HarEntryDecodeStatusSchema;
